/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import useStyles from './Styles'
import VideoCard from 'src/components/shared/modules/videoCard'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { Box } from '@mui/system'
import Divider from '@mui/material/Divider'
import { Grid } from '@mui/material'
import Modal from 'src/components/shared/modules/modal'
import YoutubeShortsPlayer from 'src/components/shared/modules/youtubeShortsPlayer'
// import UsePagination from 'src/components/shared/atoms/pagination/Pagination'
import { getVideoIDs } from 'src/utils/preprocessing'
import { useGetAllDTLOriginalQuery } from 'src/store/ApiCall/dtlOriginalApi'
import { VideoDataType } from 'src/types/store'
import orderBy from 'lodash.orderby'
interface Iprops {
  tabContent: {
    tab1: string
    tab2: string
  }
}
function Content({ tabContent }: Iprops) {
  const { classes } = useStyles()
  const { data, error } = useGetAllDTLOriginalQuery()
  const [modalState, setModalState] = React.useState(false)
  const [currentVideo, setCurrentVideo] = React.useState('')
  const [value, setValue] = React.useState(0)
  // const handlePaginationClick = (page: number | null) => console.log(page)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box>
      <Tabs
        value={value}
        className={classes.selectWrapper}
        onChange={handleChange}
        classes={{
          indicator: classes.tabsIndicator,
        }}
      >
        <Tab value={0} label={tabContent.tab1} className={classes.tab} />
        <Tab value={1} label={tabContent.tab2} className={classes.tab} />
      </Tabs>
      <Divider />
      <Grid container mt={10} pb={20} columnSpacing={{ md: 5, sm: 3, xs: 0 }}>
        {!error && data && value === 1
          ? orderBy(data.data, (item) => Number(item.attributes.viewCount), [
              'desc',
            ]).map((vid: VideoDataType, i: number) => {
              return (
                <Grid
                  item
                  lg={3}
                  md={4}
                  sm={6}
                  xs={12}
                  key={i}
                  onClick={() => {
                    setCurrentVideo(vid.attributes.videoID)
                    setModalState(!modalState)
                  }}
                  className={classes.videoCard}
                >
                  <VideoCard
                    title={vid.attributes.title || ''}
                    img={`https://img.youtube.com/vi/${vid.attributes.videoID}/hqdefault.jpg`}
                    videoID={vid.attributes.videoID}
                    views={
                      vid.attributes.viewCount
                        ? parseInt(
                            vid.attributes.viewCount.replace(/,/g, ''),
                            10
                          )
                        : 0
                    }
                  />
                </Grid>
              )
            })
          : data &&
            orderBy(data.data, (item) => item.attributes.publishedAt, [
              'desc',
            ]).map((vid: VideoDataType, i: number) => {
              return (
                <Grid
                  item
                  lg={3}
                  md={4}
                  sm={6}
                  xs={12}
                  key={i}
                  onClick={() => {
                    setCurrentVideo(vid.attributes.videoID)
                    setModalState(!modalState)
                  }}
                  className={classes.videoCard}
                >
                  <VideoCard
                    title={vid.attributes.title || ''}
                    img={`https://img.youtube.com/vi/${vid.attributes.videoID}/hqdefault.jpg`}
                    videoID={vid.attributes.videoID}
                    views={
                      vid.attributes.viewCount
                        ? parseInt(
                            vid.attributes.viewCount.replace(/,/g, ''),
                            10
                          )
                        : 0
                    }
                  />
                </Grid>
              )
            })}
        {/* for later use */}
        {/* <Grid
          className={classes.hideOnSm}
          container
          justifyContent="flex-end"
          sx={{ margin: '50px 0px' }}
           
        >
          <UsePagination
            page={1}
            pageCount={5}
            handleClick={handlePaginationClick}
          />
        </Grid> */}
      </Grid>
      <div>
        {data && modalState ? (
          <Modal closeHandler={() => setModalState(!modalState)}>
            <Box className={classes.shortsPlayerContainer}>
              <YoutubeShortsPlayer
                videoID={modalState ? currentVideo : ''}
                videoList={modalState ? getVideoIDs(data) : []}
                playerState={modalState}
              />
            </Box>
          </Modal>
        ) : null}
      </div>
    </Box>
  )
}

export default Content
